import { render, staticRenderFns } from "./FileStorage.vue?vue&type=template&id=f089d634&scoped=true"
import script from "./FileStorage.vue?vue&type=script&lang=js"
export * from "./FileStorage.vue?vue&type=script&lang=js"
import style0 from "./FileStorage.vue?vue&type=style&index=0&id=f089d634&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f089d634",
  null
  
)

export default component.exports